export const DEFAULT_IMAGE_CREDIT_COST = 10

export function estimateGeneratedImageCount({
  currentImageCount = 0,
  headlineCount = 0,
  missingAspectRatioCount = 0,
  wantsAspectRatios = false,
}) {
  if (wantsAspectRatios && headlineCount === 0) {
    return missingAspectRatioCount
  }

  if (headlineCount > 0 && !wantsAspectRatios) {
    return headlineCount * currentImageCount
  }

  if (headlineCount > 0 && wantsAspectRatios) {
    return missingAspectRatioCount + headlineCount * (missingAspectRatioCount + currentImageCount)
  }

  return 0
}

export function estimateImageGenerationCreditCost(options) {
  const costPerImage = options.costPerImage ?? DEFAULT_IMAGE_CREDIT_COST
  return estimateGeneratedImageCount(options) * costPerImage
}
